import { useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../store";
import { setAIReview } from "../store/actions";
import { updateAIReview } from "../api/aiReviewService";
import { ToastManager } from "../components/organisms/CommonUI/ToastPopup/ToastManager";
import { log, LogLevel } from "../utils/LogUtil";

export const useAIReviewMemo = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [isLoading, setIsLoading] = useState(false);

  const updateMemo = async (reviewId: number, memo: string) => {
    setIsLoading(true);
    try {
      log(LogLevel.INFO, "useAIReviewMemo:updateMemo:Updating memo", {
        reviewId,
        memoLength: memo.length,
      });

      // 1. API 호출
      const result = await updateAIReview(reviewId, { memo });

      // 2. 성공 시 Redux store 업데이트
      if (result.error === 0 && result.data) {
        dispatch(setAIReview(result.data));

        ToastManager.show({
          content: "메모가 저장되었습니다.",
          duration: 2000,
        });

        log(LogLevel.INFO, "useAIReviewMemo:updateMemo:Memo updated successfully", {
          reviewId,
          memo: result.data.memo,
        });
      } else {
        throw new Error(result.message || "메모 저장에 실패했습니다.");
      }
    } catch (error) {
      log(LogLevel.ERROR, "useAIReviewMemo:updateMemo:Failed to update memo", error);
      ToastManager.show({
        content: "메모 저장에 실패했습니다.",
        duration: 2000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return { updateMemo, isLoading };
};
